import * as React from 'react';
import styled from 'styled-components';

import { Icon } from '@creditornot/alchemy-react';
import * as icons from '@creditornot/alchemy-react/icons';
import { typographyCss } from '@creditornot/cb-ingredients';
import { color } from '@creditornot/cb-ingredients/design-tokens';
import { Spinner } from '@creditornot/cb-progress';

import { useFormatMessage } from '../../hooks/useFormatMessage';

const SubmitStateText = styled.div<{ $isMobileOptimized?: boolean }>`
  margin-top: 12px;
  ${({ $isMobileOptimized }) => ($isMobileOptimized ? typographyCss.body : typographyCss.caption)}
`;

type Props = {
  isLoading?: boolean;
  hideText?: boolean;
  loadingText?: string;
  successText?: string;
  isMobileOptimized?: boolean;
};

export const SubmitStateBadge: React.FC<Props> = ({
  isLoading,
  hideText,
  loadingText,
  successText,
  isMobileOptimized,
}) => {
  const format = useFormatMessage();

  return isLoading ? (
    <>
      <Spinner size="extraLarge" />
      {!hideText && (
        <SubmitStateText $isMobileOptimized={isMobileOptimized}>
          {loadingText ?? format('components.submit_state_badge.saving')}
        </SubmitStateText>
      )}
    </>
  ) : (
    <>
      <Icon
        source={icons.checkmarkCircleFilled.medium}
        width={64}
        height={64}
        fill={color.textBrand}
      />
      {!hideText && (
        <SubmitStateText $isMobileOptimized={isMobileOptimized} role="status" aria-live="polite">
          {successText ?? format('components.submit_state_badge.done')}
        </SubmitStateText>
      )}
    </>
  );
};
